module.exports = __webpack_public_path__ + "static/media/original.1074ec23.png";